import { getAuthToken } from "./auth";

const BASE_URL = "https://stage.getrevibe.app/api";

// ─── Auth headers ─────────────────────────────────────────────────────────────
const getHeaders = () => {
  const token = getAuthToken();
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

// ─── Fetch paginated list of available coupons ────────────────────────────────
export const getCoupons = async (page = 1, limit = 10) => {
  const response = await fetch(
    `${BASE_URL}/coupons?page=${page}&limit=${limit}`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );

  if (!response.ok) throw new Error("Failed to fetch coupons");
  return response.json();
};

// ─── Validate and apply a coupon code against a given amount ──────────────────
export const applyCoupon = async (code, amount) => {
  const response = await fetch(`${BASE_URL}/orders/apply-coupon`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ code, amount }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.message || "Invalid coupon code");
  }
  return response.json();
};

// ─── Redeem an applied coupon against a Razorpay order ───────────────────────
export const redeemCoupon = async (razorpayOrderId, code) => {
  const response = await fetch(`${BASE_URL}/orders/redeem-coupon`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ razorpay_order_id: razorpayOrderId, code }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.message || "Failed to redeem coupon");
  }
  return response.json();
};